
.global-popover {
  max-width: 500px;

  .popover-body {
    margin: 0 15px 15px 0;
    overflow-y: auto;
    overflow-x: visible;
    max-height: 500px;
  }

  .table {
    margin: 10px 0 0 0;
    padding: 0;
  }

  tr {
    line-height: normal;
  }

  td,
  th {
    vertical-align: middle;
  }

  th.label,
  td.label {
    padding-left: 0;
    padding-top: 2px;
    font-size: 12px;
    color: #666;
  }

  code {
    color: #666;
    white-space: nowrap;
    word-break: break-word;
  }

  pre {
    color: #666;
    word-break: break-word;
  }

  .popover-header {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .popover-error .popover-header {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  .popover-body {
    padding: 0;
    margin: 0;
    overflow: visible;
  }

  .popover-body hr {
    margin: 0.5rem 0;
  }

  .popover-body .popover-content {
    padding: 8px 14px;
    margin: 0;
    overflow-y: auto;
    overflow-x: visible;
    max-height: 500px;
  }

  .popover-body .popover-footer {
    margin: 0;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    background-color: #f7f7f7;
    border-top: 1px solid #ebebeb;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      display: inline-block;
      padding: 0;
      margin: 0;
    }
  }

  .container {
    padding: 0;
  }
}

/* sbb branding */
.popover {
  box-shadow: rgb(204, 204, 204) 0px 6px;
  border: 2px solid rgb(102, 102, 102);
}

.bs-popover-auto[data-popper-placement^='right'] > .arrow::before,
.bs-popover-right > .arrow::before {
  border-right-color: rgb(102, 102, 102);
}

.bs-popover-auto[data-popper-placement^='right'] > .arrow::after,
.bs-popover-right > .arrow::after {
  left: 2px;
}
